import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-19/task-01";

const task: Slide = {
  titleHtml:
    "Consider a cylindrical waveguide which diameter is 10 cm. Which modes propagate at<br>5000 Hz? Note that in the mode indexing (m,n), m stands for the number of straight<br>nodal lines (variable θ) and n stands for the number of circular nodal lines (variable r).",
  description: "Drag and drop modes.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
